<template>
  <el-dialog
    v-dialogDrag
    title="报警推送设置"
    :visible="visible"
    :close-on-click-modal="false"
    @close="handleClose"
    class="mini-dialog"
  >
    <el-form :model="formData" label-width="160px" :rules="formRules" ref="formRef">
      <el-form-item label="共存消息数" prop="msgCount">
        <el-input-number v-model="formData.msgCount" :min="0" :max="10"></el-input-number>
      </el-form-item>
      <el-form-item label="消息停留时间(S)" prop="msgDuration">
        <el-input-number v-model="formData.msgDuration" :min="0"></el-input-number>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button type="primary" size="small" @click="save" :loading="saveLoading">保存</el-button>
      <el-button size="small" @click="handleClose">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { cloneDeep, isNil } from 'lodash'
import { FenceTemplateApi } from '@wiz-api/personnel-position'
import { AlarmPushSettingsApi } from '@wiz-api/cloud-render-management'

const alarmPushSettingsApi = new AlarmPushSettingsApi()

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      saveLoading: false,
      formData: {
        msgCount: 3,
        msgDuration: 6,
      },
      formRules: {
        msgCount: { required: true, message: '请输入共存消息数', trigger: 'blur' },
        msgDuration: { required: true, message: '请输入消息停留时间', trigger: 'blur' },
      },
      operateType: 'create',
    }
  },
  async created() {
    await this.getConfig()
  },
  methods: {
    // 获取配置
    async getConfig() {
      const [err, res] = await alarmPushSettingsApi.getList()
      if (!err && !isNil(res) && !isNil(res.items)) {
        if (res.items.length) {
          this.formData = res.items[0]
          this.operateType = 'update'
        }
      }
    },
    // 关闭弹框
    handleClose() {
      this.$emit('update:visible', false)
    },
    // 保存
    save() {
      this.$refs.formRef.validate(async (valid) => {
        this.saveLoading = true
        if (valid) {
          let [err, res] = [null, null]
          if (this.operateType === 'create') {
            ;[err, res] = await alarmPushSettingsApi.create({
              body: this.formData,
            })
          } else {
            ;[err, res] = await alarmPushSettingsApi.update(this.formData.id, {
              body: this.formData,
            })
          }
          if (!err) {
            this.$message({
              showClose: true,
              message: '保存成功',
              type: 'success',
            })
            this.$emit('update:visible', false)
          }
        }
        this.saveLoading = false
      })
    },
  },
}
</script>

<style lang="scss" scoped></style>